<mat-toolbar color="blue">
  <mat-toolbar-row>
    <span>NAISignifica Virtualni Ogled</span>
    <span class="main-spacer"></span>
    <span class="valuationInfo">{{userFullName}}&nbsp;&nbsp;&nbsp;&nbsp;{{idValuation}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <button mat-mini-fab color="accent" (click)="ngOnDestroy()">
      <mat-icon>call_end</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="page">
  <div class="content">



    <div class="c1">
      <mat-form-field class="input100" appearance="outline">
        <mat-label>Mobilna številka</mat-label>
        <input matInput id="inputGsm" [readonly]="isSMSSent" [(ngModel)]="mobileNr" (keyup.enter)="sendSMS()">
        <button *ngIf="mobileNr && !isSMSSent" matSuffix mat-icon-button aria-label="Pošlji" (click)="sendSMS()">
          <mat-icon>send</mat-icon>
        </button>
      </mat-form-field>
      <!--<button mat-raised-button>Pošlji SMS</button>-->
      <mat-form-field class="input100" appearance="outline">
        <mat-label>Kopiraj povezavo</mat-label>
        <input style="color: #8B8B8B" readonly matInput [(ngModel)]="clientUrl">
        <button matSuffix mat-icon-button aria-label="Kopiraj" matTooltip="Kopiraj povezavo" (click)="copyToClipboard(clientUrl, true)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="input100" appearance="outline">
        <mat-label>GEO lokacija stranke</mat-label>
        <input style="color: #8B8B8B" readonly matInput [(ngModel)]="clientGEO">
        <button matSuffix mat-icon-button aria-label="Kopiraj" matTooltip="Kopiraj vrednost" (click)="copyToClipboard(clientGEO, true)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="input50" appearance="outline">
        <mat-select [(ngModel)]="selectedCamValue" (selectionChange)="onChangeCam()">
          <mat-option *ngFor="let cam of camArray"
                      [value]="cam.value">
            {{cam.display}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input50right" appearance="outline">
        <mat-select [(ngModel)]="selectedZoomValue" (selectionChange)="onChangeCam()">
          <mat-option *ngFor="let zoom of zoomArray"
                      [value]="zoom.value">
            {{zoom.display}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="input100" appearance="outline">
        <mat-label>Info / Log</mat-label>
        <input style="color: #8B8B8B" readonly matInput [(ngModel)]="infoInputText">


        <button matSuffix mat-icon-button  matTooltip="Povečaj stranki glasnost za 10%" (click)="increaseClientVolume(0.1)">
          <mat-icon>volume_up</mat-icon>
        </button>
        <button matSuffix mat-icon-button  matTooltip="Prikaži informacije o uporabnikovi napravi" (click)="displayInfoInputText()">
          <mat-icon>devices</mat-icon>
        </button>
        <button matSuffix mat-icon-button  matTooltip="Prenesi celoten log na računalnik" (click)="showLogs()">
          <mat-icon>dvr</mat-icon>
        </button>
      </mat-form-field>

      <video #localVideo id="localVideo" autoplay controls></video>
      <br />
      <br />




    </div>
    <div class="c2">
      <video #remoteVideo id="remoteVideo" autoplay controls></video>
    </div>
    <div class="c3">


      <mat-form-field class="input100" appearance="outline">
    
        <mat-select [(ngModel)]="selectedImgLocation">
          <mat-option value="naNamizje">Slike shranjuj na namizje</mat-option>
          <mat-option value="option2" disabled>Slike shranjuj v cenitev (disabled)</mat-option>
          <mat-option value="option1">Slike samo prikaži v brskalniku</mat-option>

        </mat-select>
      </mat-form-field>

      <button [disabled]="!isChannelReady" mat-raised-button aria-label="naredi sliko" (click)="takeClientPic()">
        Zajemi sliko&nbsp;&nbsp;&nbsp;<mat-icon>add_a_photo</mat-icon>
      </button>
      <button [disabled]="!isChannelReady" mat-raised-button aria-label="naredi sliko" (click)="takeClientPic2()">
        Zajemi lokalno sliko &nbsp;&nbsp;&nbsp;<mat-icon>add_a_photo</mat-icon>
      </button>

      <button [disabled]="!isChannelReady" mat-raised-button (click)="getClientGEO()">
        Pridobi lokacijo&nbsp;&nbsp;<mat-icon>add_location</mat-icon>
      </button>



    </div>




  </div>
  <div class="gallery" id="gallery">

    <img *ngFor="let img of imgArray" src="{{img.src}}" />

     <!--<img src="http://abload.de/img/paejgp.jpg" />
  <img src="http://abload.de/img/paejgp.jpg" />
  <img src="https://iheartcraftythings.com/wp-content/uploads/2021/05/How-to-draw-tree-7.jpg" />
  <img src="http://abload.de/img/paejgp.jpg" />
  <img src="http://abload.de/img/paejgp.jpg" />-->
  </div>
</div>

<div style="display:none">
  <canvas #canvas id="takePhotoCanvas"></canvas>
</div>
